module.exports = __webpack_public_path__ + "static/fonts/DingTalk-JinBuTi.29d20d6.woff2";